<template>
    <span class="p-no-float-label">
        <ul class="tags" v-if="selectedSkills.length > 0">
            <li v-for="skill in selectedSkills" :key="skill.name">
                {{ skill.name }}
                <Button icon="pi pi-times"
                        class="p-button-rounded p-button-outlined"
                        @click="skillRemoved(skill.id)"
                        data-cy="wizard-competences-chosen" />
            </li>
        </ul>
        <div class="skill-search">
            <AutoComplete v-model="skill" v-if="selectedSkills?.length <5"
                          id="skills"
                          data-cy="wizard-choose-competences"
                          :suggestions="skills"
                          @complete="loadSkillsForAutocomplete($event)"
                          @click="loadSkillsForAutocomplete($event)"
                          @itemSelect="skillSelected"
                          field="name"
                          :class="{ 'p-invalid': invalid }"
                          style="height: 60px; color: #ced4da !important;"
                          :placeholder="t('signup.tech.skills.label')"
                          :minLength="0"
                          ref="autocomplete"
                          />
        </div>
    </span>

</template>
<script lang="ts" setup>
    import { ref, defineProps, defineEmits, computed } from 'vue';
    import { useI18n } from 'vue-i18n';
    import { createSkillService } from '@/services/skillService';
    const { t } = useI18n();

    const props = defineProps<{
        modelValue: [];
        invalid: boolean;
    }>();

    const skill = ref();
    const autocomplete = ref();

    const emit = defineEmits(['update:modelValue'])
    const selectedSkills = computed({
        get: () => props.modelValue,
        set: (value) => {
            emit('update:modelValue', value);
        }
    });

    const skills = ref([]);

    const skillSelected = () => {
        if(!selectedSkills.value)
            selectedSkills.value = []

        if (!selectedSkills.value.find(s => s.id == skill.value.id))
            selectedSkills.value.push(skill.value);
        skill.value = "";
    };

    const skillRemoved = (id) => {
        selectedSkills.value = selectedSkills.value.filter(x=>x.id != id);
    };

    const loadSkillsForAutocomplete = async (event) => {
        const service = await createSkillService();
        let query = "";
        if (event.query)
            query = event.query.trim()
        const data = await service.getTechSkillsByName(query);
        skills.value = data.data.data;
        autocomplete.value.show();
    };
</script>

